import prettyBytes from 'pretty-bytes'

export default {
  install: function (Vue, options) {
    Vue.filter('prettyBytes', function (value) {
      return prettyBytes(value)
    })
  }
}



// WEBPACK FOOTER //
// ./src/plugins/prettybytes.js